var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A9BBBC",
    fillRule: "evenodd",
    d: "M2.03.97L.97 2.03 4.017 5.08c-.284.235-.565.488-.843.757-.622.601-1.185 1.243-1.68 1.886-.299.387-.511.692-.627.874L.609 9l.259.404c.116.182.328.487.627.874.495.643 1.058 1.285 1.68 1.886C4.998 13.927 6.954 15 9 15c1.29 0 2.545-.427 3.754-1.185l3.215 3.215 1.061-1.06-15-15zm9.628 11.75l-1.134-1.136C10.077 11.848 9.556 12 9 12c-1.657 0-3-1.343-3-3 0-.556.151-1.077.415-1.524l-1.33-1.33c-.291.234-.58.49-.867.768-.566.547-1.082 1.136-1.535 1.724-.098.127-.188.248-.271.362.083.114.173.235.271.362.453.588.969 1.177 1.535 1.724C5.788 12.604 7.42 13.5 9 13.5c.876 0 1.769-.276 2.658-.78zM7.55 8.61c-.033.124-.05.255-.05.389 0 .828.671 1.5 1.5 1.5.134 0 .264-.018.388-.05L7.55 8.61zm7.523 3.307l-1.06-1.06c.475-.481.912-.989 1.303-1.496.098-.127.189-.248.271-.362-.082-.114-.173-.235-.27-.362-.454-.588-.97-1.177-1.535-1.724C12.212 5.396 10.578 4.5 9 4.5c-.392 0-.787.055-1.184.161L6.63 3.475C7.404 3.166 8.195 3 9 3 11.045 3 13 4.073 14.824 5.836c.622.601 1.185 1.243 1.68 1.886.3.387.511.692.627.874L17.39 9l-.259.404c-.116.182-.328.487-.627.874-.428.556-.907 1.111-1.43 1.64z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCloseIcon);
export default __webpack_public_path__ + "static/media/EyeCloseIcon.99eef28a.svg";
export { ForwardRef as ReactComponent };